import Circle from "../LogoSVG/Circle";
import Arrow from "../LogoSVG/Arrow";

function TeknikMobile() {
  return (
    <a className="pt-20" href="https://www.optimizer.co.jp/en/" target="_blank">
      <div className=" text-gray-4 mb-1.5 text-[15px]">Jul 2022 - Feb 2023</div>

      <div className="text-[16px] font-medium mb-2">
        Software Engineer
        <Circle className="mx-1.5 h-1 w-1 inline align-middle" />
        Optimizer{" "}
        <span className="whitespace-nowrap">
          Inc. <Arrow className="inline align-middle" />
        </span>
      </div>

      <div className=" text-gray-5 mb-12 text-[16px]">
        <div className="flex flex-row items-start mb-2">
          <span>
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
          </span>
          <div className="text-gray-4 ">
            Conducted research on transforming 2D images into 3D models
          </div>
        </div>

        <div className="flex flex-row items-start mb-2">
          <span>
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
          </span>
          <div className="text-gray-4 ">
            Developed a Japanese 3D e-commerce platform for online purchases and
            personalized 3D object-building mechanics (90% object-catching
            accuracy)
          </div>
        </div>
      </div>
    </a>
  );
}

export default TeknikMobile;
